enum VoteWeight {
  niceToHave = 0,
  important = 10,
  mustHave = 20,
}

export default VoteWeight;
